<button mat-button [matMenuTriggerFor]="exclusionMenu">
  {{ labelTranslationKey | translate }}
  <mat-icon>filter_list</mat-icon>
</button>
<mat-menu #exclusionMenu="matMenu">
  @for (option of optionsArray; track option.id) {
    <button mat-menu-item (click)="$event.stopPropagation()">
      <mat-checkbox [ngModel]="option.value" (ngModelChange)="toggleOption(option.id)" class="menu-checkbox">
        {{ 'ADMIN.EXCLUSION_LABEL.' + option.id | translate }}
      </mat-checkbox>
    </button>
  }
</mat-menu>
